import { PageView } from '../../components/Analytics/PageView/PageView'
import { useEffect, useState,useMemo } from "react"
import ReactHtmlParser from 'react-html-parser'
import { TextAPI } from '../../api/TextAPI'
import Head from 'next/head';

const title = "CONTACT US"
const textType = 'contact_us_body'

export default function ContactPage() {

  const [ bodyText, setBodyText ] = useState("")

  const textAPI = useMemo(() => new TextAPI(process.env.NEXT_PUBLIC_API_BASE_URL ?? ''), [])

  useEffect(() => {
    textAPI.getByType(textType).then(text => text && setBodyText(text.body))
  }, [textAPI])

  return (
    <main className='contact-us' id='maincontent'>
      <Head key={'contact-us'}><title>Universal Orlando™ | Contact us</title></Head>
      <PageView
        pageName='Contact Us'
        subCategory1='Plan Your Visit'
        subCategory2='Hours Information'
        subCategory3='Contact Us'
      />
      <h1>{title}</h1>
      { ReactHtmlParser(bodyText) }
    </main>
  )
}
